<nav class="open">
	<ul>
		<li class="title-row">
			<strong>Consumer Key:</strong>
		</li>
		<li *ngFor="let consumerKey of consumerKeys">
			<a routerLink="./{{stringUtil.encode(consumerKey)}}" class="{{setActiveNode(consumerKey)}}">
				{{consumerKey}}
			</a>
		</li>
	</ul>
</nav>